import { render, staticRenderFns } from "./TourModal.vue?vue&type=template&id=6dd7ef44"
import script from "./TourModal.vue?vue&type=script&lang=js"
export * from "./TourModal.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./TourModal.vue?vue&type=style&index=0&id=6dd7ef44&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports